import { render, staticRenderFns } from "./ConceptProductForm.vue?vue&type=template&id=4442deb1&scoped=true&"
import script from "./ConceptProductForm.vue?vue&type=script&lang=ts&"
export * from "./ConceptProductForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConceptProductForm.vue?vue&type=style&index=0&id=4442deb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4442deb1",
  null
  
)

export default component.exports